import React from "react";
import ContactForm from "../../apartment-detail-view/components/ContactForm";

const RoomContactForm = ({ room, prefillDates }) => {
  return <ContactForm apartment={room} prefillDates={prefillDates} />;
};

export default RoomContactForm;
